var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('CsvImportModal', {
    ref: "csvUploaderModal",
    attrs: {
      "baseData": _vm.dataGenerateCSV
    },
    on: {
      "on-generate-success": _vm.handleGenerateSuccess,
      "item-ids-data": _vm.handleIdItem,
      "on-save-success": _vm.tableDataItem
    }
  }), _c('AddContentModal', {
    ref: "addContentModalRef",
    on: {
      "on-save-success": _vm.tableDataItem
    }
  }), _vm._m(0), _c('div', {
    staticClass: "overflow-x-auto relative bg-white px-4 space-y-5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center w-full space-y-4"
  }, [_c('div', {
    staticClass: "relative w-96"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchItemQuery,
      expression: "searchItemQuery"
    }],
    staticClass: "search-input p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg",
    attrs: {
      "placeholder": "Search by Book Name",
      "type": "search"
    },
    domProps: {
      "value": _vm.searchItemQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchItemQuery = $event.target.value;
      }, _vm.onSearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      }
    }
  })]), _c('div', {
    staticClass: "flex space-x-3"
  }, [_c('Button', {
    staticClass: "flex border space-x-2 justify-center items-start",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.csvUploaderModal.openModal();
      }
    }
  }, [_c('div', {
    staticClass: "text-xs text-gray-700 flex justify-center items-center"
  }, [_vm._v("Import CSV")])]), _c('Button', {
    staticClass: "flex border space-x-2 justify-center items-start",
    attrs: {
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.addContentModalRef.openModal();
      }
    }
  }, [_c('div', {
    staticClass: "text-xs flex text-white justify-center items-center"
  }, [_vm._v("Add Content")])])], 1)]), _c('div', {
    staticClass: "rounded-xl overflow-auto mb-4 relative border-t border-b border-l border-r"
  }, [_vm.isLoadingLocationItems ? _c('div', {
    staticClass: "left-0 top-0 bottom-0 right-0 w-full h-full absolute bg-white"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _c('table', {
    staticClass: "w-full text-sm text-left text-gray-500"
  }, [_vm._m(1), _c('tbody', [_vm._l(_vm.locationItems, function (item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "bg-white hover:bg-gray-50",
      class: {
        'border-b': index !== _vm.locationItems.length - 1
      }
    }, [_c('td', {
      staticClass: "px-6 py-2.5 font-medium text-gray-900"
    }, [_vm._v(" " + _vm._s((_vm.currentPageItem - 1) * _vm.limitItem + index + 1) + " ")]), _c('td', {
      staticClass: "px-6 py-2.5 font-medium text-gray-900"
    }, [item.thumb_image_normal ? _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": 'https://ebooks.gramedia.com/ebook-covers/' + _vm.removeBucket(item.thumb_image_normal)
      }
    }) : _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": _vm.DefaultImage,
        "alt": "empty thumb"
      }
    })]), _c('td', {
      staticClass: "px-6 py-2.5"
    }, [_vm._v(_vm._s(item.name))]), _c('td', {
      staticClass: "px-6 py-2.5 capitalize"
    }, [_vm._v(_vm._s(item.item_type || item.type))]), _c('td', {
      staticClass: "px-6 py-2.5 capitalize"
    }, [_c('Button', {
      staticClass: "flex border space-x-0 justify-center items-start",
      attrs: {
        "variant": "outlined",
        "color": "alternative",
        "size": "sm"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteItem(item);
        }
      }
    }, [_c('div', {
      staticClass: "text-xs text-gray-700 flex justify-center items-center"
    }, [_c('svg', {
      staticClass: "w-5 h-5 mr-1 text-gray-800 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "none",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "stroke": "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        "d": "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
      }
    })]), _vm._v(" Remove ")])])], 1)]);
  }), _vm.locationItems.length === 0 && !_vm.searchItemQuery ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "flex flex-col justify-center space-y-3 items-center p-4"
  }, [_c('img', {
    staticClass: "w-12 h-12",
    attrs: {
      "src": _vm.noItem
    }
  }), _c('h5', {
    staticClass: "font-bold leading-6 text-gray-900"
  }, [_vm._v("No SmartPin Content Yet")]), _c('p', {
    staticClass: "text-gray-500 text-sm mt-2"
  }, [_vm._v("Add content to create your SmartPin Content List.")])])])]) : _vm._e(), _vm.locationItems.length === 0 && _vm.searchItemQuery ? _c('tr', [_vm._m(2)]) : _vm._e()], 2)])]), _vm.totalLocationItems / _vm.limitItem > 1 ? _c('div', {
    staticClass: "flex bg-white items-start justify-between ml-0 pt-0 align-middle px-0"
  }, [_c('div', {
    staticClass: "font-semibold mt-1"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPageItem) + "-" + _vm._s(_vm.limitItem) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalLocationItems)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalLocationItems),
      "per-page": _vm.limitItem
    },
    model: {
      value: _vm.currentPageItem,
      callback: function ($$v) {
        _vm.currentPageItem = $$v;
      },
      expression: "currentPageItem"
    }
  })], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white flex-col justify-between items-center p-4 shadow-sm rounded-lg mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "font-bold text-lg leading-5 mb-3"
  }, [_vm._v("SmartPin Content List")])]), _c('div', {
    staticClass: "bg-gray-50 p-3 rounded-lg text-gray-800"
  }, [_c('label', {
    staticClass: "text-base font-semibold mb-1"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info mr-2"
  }), _vm._v(" Only eligible content is displayed to users.")]), _c('p', {
    staticClass: "text-sm font-normal mb-1"
  }, [_vm._v("Content must be Visible, Active, For Sale, and Ready to Consume, and is available only within the selected access radius.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "text-xs text-gray-700 uppercase bg-gray-50"
  }, [_c('tr', [_c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("image")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("book name")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("type")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "flex flex-col justify-center space-y-3 items-center p-4"
  }, [_c('p', {
    staticClass: "text-gray-500 text-sm mt-2"
  }, [_vm._v("No data available.")])])]);
}]

export { render, staticRenderFns }